import React, { useState } from "react"
import { Col, Form, Row, Card, Input, Button } from "antd"
import { useHistory } from "react-router-dom"
import SettingsPageSimple from "components-old/common/SettingsPage/SettingsPageSimple"
import request from "lib/request"
import { endpoints } from "config/endpoints.config"
import toast from "lib/toast"
import { isAldeia } from "hooks/useAldeia"
import FormModal from "components-old/forms/FormModal"
import StarAlert from "../StarAlert"

export const EmailOutlookLogoBase64 =
  "data:image/svg+xml;charset=utf-8;base64,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"

function AddEmailOutlook() {
  const [form] = Form.useForm()
  const [saving, setSaving] = useState(false)
  const history = useHistory()
  const [open, setOpen] = useState(true)

  const close = (cb: () => void) => {
    setOpen(false)
    // setTimeout(() => {
    cb()
    // }, 150)
  }

  if (isAldeia) {
    return (
      <FormModal
        form={form}
        visible={open}
        // noPrompt
        onSubmit={async (model: any) => {
          return request
            .post(endpoints.EMAIL, { ...model, identifier: model.extraData.outlookData.graphSender })
            .then((a) => {
              toast.success("Canal de Outlook criado.")
              history.push("/settings/channels/" + a.data.id)
            })
            .finally(() => {
              setSaving(false)
            })
        }}
        onBack={() => close(() => history.push("/settings/channels/new/email"))}
        type="drawer"
        width={600}
        titleOverwrite={
          <span className="flex gap-3 items-center text-lg">
            <div className="size-8">{<img src={EmailOutlookLogoBase64} />}</div>
            Conectar Outlook
          </span>
        }
        // stickyFooter
        onSubmitSuccess={() => {
          history.push("/settings/channels")
        }}
        okText="Conectar canal"
        stickyFooter
      >
        <StarAlert className="!px-3 mb-4 gap-3" type="info">
          <div className="text-sm">
            <p>
              Você pode ler e responder mensagens que seus clientes enviam para o e-mail existente do seu time (e.g: contato@suaempresa.com)
              diretamente na {isAldeia ? "Aldeia" : "Kinbox"}.
            </p>
          </div>
        </StarAlert>
        <Form.Item
          label="Descrição"
          name="description"
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          label="Tenant ID"
          name={["extraData", "outlookData", "tenantId"]}
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          label="Client ID"
          name={["extraData", "outlookData", "clientId"]}
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          label="Client Secret"
          name={["extraData", "outlookData", "clientSecret"]}
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          label="Graph Sender"
          name={["extraData", "outlookData", "graphSender"]}
          rules={[
            {
              required: true,
              message: "Campo obrigatório",
            },
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
      </FormModal>
    )
  }

  return (
    <SettingsPageSimple
      style={{
        width: 600,
      }}
      title={
        <Row align="middle">
          Canais {"> "}
          <Row align="middle">
            <span
              style={{
                width: 24,
                height: 24,
                display: "flex",
                marginRight: 10,
                marginLeft: 10,
              }}
            >
              <img src={EmailOutlookLogoBase64} alt="" className="size-full" />
            </span>
            Outlook
          </Row>
        </Row>
      }
      tabTitle="Canais > E-mail"
      helpText={
        <span>Conecte-se aos aplicativos de mensagens mais usados pelos seus clientes e responda todos em sua caixa de entrada.</span>
      }
      // center
      onBack={() => history.push("/settings/channels/new")}
      backTo="/settings/channels/new"
    >
      <div
        style={{
          fontSize: 16,
          color: "var(--content-secondary)",
          marginLeft: 5,
          marginBottom: 20,
        }}
      >
        <p>
          Você pode ler e responder mensagens que seus clientes enviam para o e-mail existente do seu time (e.g: contato@suaempresa.com)
          diretamente no Kinbox.
        </p>
        <br />
      </div>
      <Form
        layout="vertical"
        form={form}
        onFinish={(model) => {
          setSaving(true)
          request
            .post(endpoints.EMAIL, { ...model, identifier: model.extraData.outlookData.graphSender })
            .then((a) => {
              toast.success("Canal de E-mail criado.")
              history.push("/settings/channels/" + a.data.id)
            })
            .finally(() => {
              setSaving(false)
            })
        }}
      >
        <Card className="gray">
          <Form.Item
            label="Descrição"
            name="description"
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            label="Tenant ID"
            name={["extraData", "outlookData", "tenantId"]}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            label="Client ID"
            name={["extraData", "outlookData", "clientId"]}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            label="Client Secret"
            name={["extraData", "outlookData", "clientSecret"]}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            label="Graph Sender"
            name={["extraData", "outlookData", "graphSender"]}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <Input placeholder="" />
          </Form.Item>
        </Card>
        <br />
        <Row>
          <Button type="primary" htmlType="submit" loading={saving}>
            Criar canal
          </Button>
        </Row>
      </Form>
    </SettingsPageSimple>
  )
}

export default AddEmailOutlook
